module.exports = __webpack_public_path__ + "static/media/boba-fett.3e78641e.jpg";